import { queryCache, useQuery } from 'react-query'

import { createContainer } from '@sponte/lib-utils/dist/hooks/useContainer'

const updateAuthData = (data) => queryCache.setQueryData('auth', data)

function useAuthHook({ bootstrap, onLogin, onLogout, onChangeEu, onChangePassword }) {
  const { data: eu } = useQuery('auth', bootstrap)

  const login = (values) => onLogin(values).then(updateAuthData)
  const logout = () => onLogout().then(() => window.location.reload())
  const changeEu = (values) => onChangeEu(values).then(updateAuthData)
  const changePassword = (values) => onChangePassword(values).then(updateAuthData)

  return {
    eu,
    login,
    logout,
    changeEu,
    changePassword
  }
}

export const [AuthProvider, useAuth] = createContainer(useAuthHook)
